<template>
  <v-chip label
          size="small"
          variant="flat"
          class="text-body-2 AppSignatureStatus rounded-pill"
          data-locator="file-status"
  >
    <span class="font-weight-bold">{{ $t(`common.envelopeStatus.${status}`) }}</span>
  </v-chip>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

const STATUS_STYLE_MAP: Record<string, { color: string; backgroundColor: string }> = {
  draft : {
    color: 'text-inverted',
    backgroundColor: 'surface-neutral-bold',
  },
  temp : {
    color: 'text-inverted',
    backgroundColor: 'surface-neutral-bold',
  },
  sending : {
    color: 'text-warning',
    backgroundColor: 'surface-warning-bold',
  },
  queued : {
    color: 'text-warning',
    backgroundColor: 'surface-warning-bold',
  },
  sent : {
    color: 'text-warning',
    backgroundColor: 'surface-warning-bold',
  },
  signed : {
    color: 'text-inverted',
    backgroundColor: 'surface-success-bold',
  },
  voided : {
    color: 'text-inverted',
    backgroundColor: 'surface-danger-bold',
  },
  unvalidated : {
    color: 'text-warning',
    backgroundColor: 'surface-warning-bold',
  },
  error : {
    color: 'text-inverted',
    backgroundColor: 'surface-danger-bold',
  },
}

const DEFAULT_STYLE = { color: 'text-inverted', backgroundColor: 'surface-neutral-bold' }

/**
 * Default Signature status
 * @displayName AppSignatureStatus
 */
export default defineComponent({
  name: 'AppSignatureStatus',
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    style (): { color: string; backgroundColor: string } {
      return STATUS_STYLE_MAP[this.status] ?? DEFAULT_STYLE
    },
    color (): string {
      return `rgb(var(--v-theme-${this.style.color}))`
    },
    backgroundColor (): string {
      return `rgb(var(--v-theme-${this.style.backgroundColor}))`
    },
  },
})
</script>
<style scoped lang="scss">
.AppSignatureStatus {
  background-color: v-bind(backgroundColor);
  color: v-bind(color);
}
</style>
